import { render, staticRenderFns } from "./VueDragTree.vue?vue&type=template&id=35c03fd8"
import script from "./VueDragTree.vue?vue&type=script&lang=js"
export * from "./VueDragTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports